import { render, staticRenderFns } from "./apiget_apizmjcdome.vue?vue&type=template&id=1f72ce72"
import script from "./apiget_apizmjcdome.vue?vue&type=script&lang=js"
export * from "./apiget_apizmjcdome.vue?vue&type=script&lang=js"
import style0 from "./apiget_apizmjcdome.vue?vue&type=style&index=0&id=1f72ce72&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports